import React from 'react';
import css from './ListingPage.module.css';
// import { ListSlider } from '../../components';
import { cardRenderSizes, isArrayLength } from '../../util/genericHelpers';

import Slider from 'react-slick';
import '../../styles/slick/slick.css';
import '../../styles/slick/slick-theme.css';
import { Icons, ListingCard } from '../../components';
import classNames from 'classnames';
const SectionMostPopular = props => {
  const { viewport, listings } = props;
  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;
  const sliderSettings = {
    dots: false,
    arrows: true,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 2000,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    variableWidth: false,
    focusOnSelect: false,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1128,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div className={classNames(css.moreItemSeller, css.mostPopular)}>
      <h2 className={css.sectionTitle}>
        Shop our most popular Footwear <Icons name="rightArrow" />
      </h2>
      <Slider {...sliderSettings} arrows={!isMobileLayout}>
        <div className={css.popularCard}>
          <div className={css.popularCardImg}>
            <img
              src="https://sharetribe.imgix.net/6824965f-cd38-4bc6-9dd4-1ac46b50d8e8/68ca5c88-293a-4602-a7a7-a3f6d0b6cc64?auto=format&crop=edges&fit=crop&h=400&w=400&s=8521fac7b7e4f5cc8964b9a7d4ddd8a6"
              alt=""
            />
          </div>
          <div className={css.popularCardInfo}>
            <h2>F50 x Bape</h2>
            <p>
              <span>92</span> available
            </p>
          </div>
        </div>
        <div className={css.popularCard}>
          <div className={css.popularCardImg}>
            <img
              src="https://sharetribe.imgix.net/6824965f-cd38-4bc6-9dd4-1ac46b50d8e8/68ca5c88-293a-4602-a7a7-a3f6d0b6cc64?auto=format&crop=edges&fit=crop&h=400&w=400&s=8521fac7b7e4f5cc8964b9a7d4ddd8a6"
              alt=""
            />
          </div>
          <div className={css.popularCardInfo}>
            <h2>F50 x Bape</h2>
            <p>
              <span>92</span> available
            </p>
          </div>
        </div>
        <div className={css.popularCard}>
          <div className={css.popularCardImg}>
            <img
              src="https://sharetribe.imgix.net/6824965f-cd38-4bc6-9dd4-1ac46b50d8e8/68ca5c88-293a-4602-a7a7-a3f6d0b6cc64?auto=format&crop=edges&fit=crop&h=400&w=400&s=8521fac7b7e4f5cc8964b9a7d4ddd8a6"
              alt=""
            />
          </div>
          <div className={css.popularCardInfo}>
            <h2>F50 x Bape</h2>
            <p>
              <span>92</span> available
            </p>
          </div>
        </div>
        <div className={css.popularCard}>
          <div className={css.popularCardImg}>
            <img
              src="https://sharetribe.imgix.net/6824965f-cd38-4bc6-9dd4-1ac46b50d8e8/68ca5c88-293a-4602-a7a7-a3f6d0b6cc64?auto=format&crop=edges&fit=crop&h=400&w=400&s=8521fac7b7e4f5cc8964b9a7d4ddd8a6"
              alt=""
            />
          </div>
          <div className={css.popularCardInfo}>
            <h2>F50 x Bape</h2>
            <p>
              <span>92</span> available
            </p>
          </div>
        </div>
        <div className={css.popularCard}>
          <div className={css.popularCardImg}>
            <img
              src="https://sharetribe.imgix.net/6824965f-cd38-4bc6-9dd4-1ac46b50d8e8/68ca5c88-293a-4602-a7a7-a3f6d0b6cc64?auto=format&crop=edges&fit=crop&h=400&w=400&s=8521fac7b7e4f5cc8964b9a7d4ddd8a6"
              alt=""
            />
          </div>
          <div className={css.popularCardInfo}>
            <h2>F50 x Bape</h2>
            <p>
              <span>92</span> available
            </p>
          </div>
        </div>
        <div className={css.popularCard}>
          <div className={css.popularCardImg}>
            <img
              src="https://sharetribe.imgix.net/6824965f-cd38-4bc6-9dd4-1ac46b50d8e8/68ca5c88-293a-4602-a7a7-a3f6d0b6cc64?auto=format&crop=edges&fit=crop&h=400&w=400&s=8521fac7b7e4f5cc8964b9a7d4ddd8a6"
              alt=""
            />
          </div>
          <div className={css.popularCardInfo}>
            <h2>F50 x Bape</h2>
            <p>
              <span>92</span> available
            </p>
          </div>
        </div>
      </Slider>
    </div>
  );
};

export default SectionMostPopular;
